import { useState, useEffect } from 'react'

export function useMatchMedia (query) {
  const [matches, setMatches] = useState(false)

  useEffect(() => {
    const media = window.matchMedia(query)

    setMatches(media.matches)

    function onMediaMatch ({ matches }) {
      setMatches(matches)
    }

    media.addListener(onMediaMatch)

    return function () {
      media.removeListener(onMediaMatch)
    }
  }, [])

  return matches
}
